import 'whatwg-fetch';

var countViews = function () {

    var body;

    var viewCounts = {};
    var items;

    var _init = function () {

        body = document.body;
        items = document.querySelectorAll('span[data-view-type]');

        window.addEventListener('load', function () {
            _onLoad();
        });

    }

    var _onLoad = function () {

        if (items.length > 0) {

            for (var i = 0; i < items.length; i++) {

                const viewType = items[i].dataset.viewType;
                const id = items[i].dataset.viewId;

                if (typeof viewCounts[viewType] == "undefined") {
                    viewCounts[viewType] = [];
                }

                viewCounts[viewType].push(id);
            }

            var url = '/api/2.0/view/';

            fetch(url, {
                method: 'POST',
                cache: 'no-cache',
                credentials: 'same-origin',
                body: JSON.stringify({
                    action: 'count_view',
                    counts: viewCounts,

                })
            });
        }
    }

    return {
        init: _init
    }

}();

countViews.init();
